import styled from 'styled-components'
import { themeGet } from 'styled-system'
import { FormInputSelect, HeaderTwo, CheckBox } from 'secondstep-components'

export const ProgramRoleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  margin-top: -0.375rem;
  margin-bottom: 1.25rem;
`

export const ProgramRoleHeader = styled(HeaderTwo)`
  font-family: ${themeGet('font.sharpSlab.semibold')};
  color: ${themeGet('colors.darkBlue')};
  text-align: start;
  margin-bottom: 1.063rem;
`

export const FieldQuestionLabel = styled.label`
  font-family: ${themeGet('font.molde.medium')};
  font-size: 1rem;
  line-height: ${themeGet('spacing.turquoise20_1_25rem')};
  color: ${themeGet('colors.darkGray')};
  margin-bottom: 0.563rem;
`

export const SelectField = styled(FormInputSelect)`
  width: 100%;
  margin-bottom: ${themeGet('spacing.turquoise20_1_25rem')};
  button {
    height: 43px;
    border: 1.5px solid ${themeGet('colors.blueGrayMedium')};
  }
  label {
    font-family: ${themeGet('font.molde.medium')};
    font-size: 0.75rem;
    line-height: ${themeGet('spacing.turquoise20_1_25rem')};
  }

  label,
  input {
    color: ${themeGet('colors.darkGray')};
  }

  &:first-of-type {
    margin-bottom: 1.5rem;
  }
`

export const ApplyAllWrapper = styled.div`
  margin-top: 0;
  margin-bottom: 1rem;
`

export const ApplyAllLabel = styled.label`
  display: block;
  font-family: ${themeGet('font.molde.medium')};
  font-size: 1rem;
  line-height: ${themeGet('spacing.turquoise20_1_25rem')};
  color: ${themeGet('colors.darkGray')};
  margin-bottom: 0.563rem;
`

export const StyledCheckbox = styled(CheckBox).attrs(props => ({
  borderColor: themeGet('colors.checkboxes.backgroundCheckedColor')(props),
  backgroundCheckedColor: themeGet('colors.checkboxes.backgroundCheckedColor')(
    props,
  ),
  backgroundCheckedColorHover: themeGet(
    'colors.checkboxes.backgroundCheckedColorHover',
  )(props),
}))`
  display: flex;
  align-items: center; /* vertically center box with label text */
  margin: 0.5rem 0 0 0;
  font-size: 1rem;

  & label {
    font-family: ${themeGet('font.molde.regular')};
    color: ${themeGet('colors.darkGray')};
    /* nudge the checkmark down to vertically center with text */
    align-items: center;
  }

  [class*='CheckBoxStyled-sc-'] {
    width: 1.25rem; /* larger to match mock */
    height: 1.25rem;
    margin-top: -0.1rem;
    padding-top: 0; /* keep check centered inside */
    border: 0.125rem solid ${({ borderColor }) => borderColor} !important;
    border-radius: 0.375rem; /* rounded-square like mock */
  }

  [class*='CheckBoxHidden']:checked ~ [class*='CheckBoxStyled'] {
    color: ${themeGet('colors.white')};
    background: ${({ backgroundCheckedColor }) => backgroundCheckedColor};
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  & label {
    align-items: center;
  }

  &:hover {
    [class*='CheckBoxStyled-sc-'] {
      border: 0.125rem solid
        ${({ backgroundCheckedColorHover }) => backgroundCheckedColorHover} !important;
    }
    [class*='CheckBoxHidden']:checked ~ [class*='CheckBoxStyled'] {
      background: ${({ backgroundCheckedColorHover }) =>
        backgroundCheckedColorHover};
    }
  }
`
